// Generated by purs version 0.15.15
import * as $foreign from "./foreign.js";
import * as Control_Apply from "../Control.Apply/index.js";
import * as Data_Boolean from "../Data.Boolean/index.js";
import * as Data_Bounded from "../Data.Bounded/index.js";
import * as Data_Date from "../Data.Date/index.js";
import * as Data_Date_Component from "../Data.Date.Component/index.js";
import * as Data_DateTime from "../Data.DateTime/index.js";
import * as Data_DateTime_Instant from "../Data.DateTime.Instant/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Enum from "../Data.Enum/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Int from "../Data.Int/index.js";
import * as Data_JSDate from "../Data.JSDate/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Number_Format from "../Data.Number.Format/index.js";
import * as Data_Numeric from "../Data.Numeric/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_String_CodePoints from "../Data.String.CodePoints/index.js";
import * as Data_String_CodeUnits from "../Data.String.CodeUnits/index.js";
import * as Data_Time from "../Data.Time/index.js";
import * as Data_Time_Component from "../Data.Time.Component/index.js";
import * as Data_Time_Duration from "../Data.Time.Duration/index.js";
import * as Effect from "../Effect/index.js";
import * as Effect_Now from "../Effect.Now/index.js";
var map = /* #__PURE__ */ Data_Functor.map(Effect.functorEffect);
var apply = /* #__PURE__ */ Control_Apply.apply(Data_Maybe.applyMaybe);
var map1 = /* #__PURE__ */ Data_Functor.map(Data_Maybe.functorMaybe);
var toEnum = /* #__PURE__ */ Data_Enum.toEnum(Data_Time_Component.boundedEnumHour);
var toEnum1 = /* #__PURE__ */ Data_Enum.toEnum(Data_Time_Component.boundedEnumMinute);
var toEnum2 = /* #__PURE__ */ Data_Enum.toEnum(Data_Time_Component.boundedEnumSecond);
var toEnum3 = /* #__PURE__ */ Data_Enum.toEnum(Data_Time_Component.boundedEnumMillisecond);
var toEnum4 = /* #__PURE__ */ Data_Enum.toEnum(Data_Date_Component.boundedEnumYear);
var toEnum5 = /* #__PURE__ */ Data_Enum.toEnum(Data_Date_Component.boundedEnumMonth);
var toEnum6 = /* #__PURE__ */ Data_Enum.toEnum(Data_Date_Component.boundedEnumDay);
var fromJust = /* #__PURE__ */ Data_Maybe.fromJust();
var diff = /* #__PURE__ */ Data_Date.diff(Data_Time_Duration.durationMilliseconds);
var add = /* #__PURE__ */ Data_Numeric.add(Data_Numeric.additiveNumber);
var show = /* #__PURE__ */ Data_Show.show(Data_Show.showInt);
var fromEnum = /* #__PURE__ */ Data_Enum.fromEnum(Data_Time_Component.boundedEnumHour);
var fromEnum1 = /* #__PURE__ */ Data_Enum.fromEnum(Data_Time_Component.boundedEnumMinute);
var fromEnum2 = /* #__PURE__ */ Data_Enum.fromEnum(Data_Time_Component.boundedEnumSecond);
var fromEnum3 = /* #__PURE__ */ Data_Enum.fromEnum(Data_Time_Component.boundedEnumMillisecond);
var fromEnum4 = /* #__PURE__ */ Data_Enum.fromEnum(Data_Date_Component.boundedEnumYear);
var fromEnum5 = /* #__PURE__ */ Data_Enum.fromEnum(Data_Date_Component.boundedEnumMonth);
var fromEnum6 = /* #__PURE__ */ Data_Enum.fromEnum(Data_Date_Component.boundedEnumDay);
var adjust = /* #__PURE__ */ Data_DateTime.adjust(Data_Time_Duration.durationDays);
var bottom = /* #__PURE__ */ Data_Bounded.bottom(Data_Time.boundedTime);
var today = /* #__PURE__ */ map(function ($44) {
    return Data_DateTime.date(Data_DateTime_Instant.toDateTime($44));
})(Effect_Now.now);
var parseISOTime = /* #__PURE__ */ (function () {
    var toTime = function (x) {
        return apply(apply(apply(map1(Data_Time.Time.create)(toEnum(x.hour)))(toEnum1(x.minute)))(toEnum2(x.second)))(toEnum3(x.millisecond));
    };
    return $foreign.parseRawTime(Data_Maybe.Nothing.value)(toTime);
})();
var parseISODateTime = /* #__PURE__ */ (function () {
    var toDateTime = function (x) {
        return apply(map1(Data_DateTime.DateTime.create)(apply(apply(map1(Data_Date.canonicalDate)(toEnum4(x.year)))(toEnum5(x.month)))(toEnum6(x.day))))(apply(apply(apply(map1(Data_Time.Time.create)(toEnum(x.hour)))(toEnum1(x.minute)))(toEnum2(x.second)))(toEnum3(x.millisecond)));
    };
    return $foreign.parseRawDateTime(Data_Maybe.Nothing.value)(toDateTime);
})();
var parseISODateTimeEither = /* #__PURE__ */ (function () {
    var $45 = Data_Either.note("invalid datetime");
    return function ($46) {
        return $45(parseISODateTime($46));
    };
})();
var parseISODate = /* #__PURE__ */ (function () {
    var toDate = function (x) {
        return apply(apply(map1(Data_Date.canonicalDate)(toEnum4(x.year)))(toEnum5(x.month)))(toEnum6(x.day));
    };
    return $foreign.parseRawDate(Data_Maybe.Nothing.value)(toDate);
})();
var padLeft = function ($copy_ch) {
    return function ($copy_n) {
        return function ($copy_str) {
            var $tco_var_ch = $copy_ch;
            var $tco_var_n = $copy_n;
            var $tco_done = false;
            var $tco_result;
            function $tco_loop(ch, n, str) {
                if (Data_String_CodePoints.length(str) < n) {
                    $tco_var_ch = ch;
                    $tco_var_n = n;
                    $copy_str = Data_String_CodeUnits.fromCharArray([ ch ]) + str;
                    return;
                };
                if (Data_Boolean.otherwise) {
                    $tco_done = true;
                    return str;
                };
                throw new Error("Failed pattern match at DateUtils (line 118, column 1 - line 118, column 43): " + [ ch.constructor.name, n.constructor.name, str.constructor.name ]);
            };
            while (!$tco_done) {
                $tco_result = $tco_loop($tco_var_ch, $tco_var_n, $copy_str);
            };
            return $tco_result;
        };
    };
};
var midnightInMillisecondsSinceEpoch = function (date) {
    var unsafeToEnum = function (dictBoundedEnum) {
        var toEnum7 = Data_Enum.toEnum(dictBoundedEnum);
        return function (x) {
            return fromJust(toEnum7(x));
        };
    };
    var epoch = Data_Date.canonicalDate(unsafeToEnum(Data_Date_Component.boundedEnumYear)(1970))(unsafeToEnum(Data_Date_Component.boundedEnumMonth)(1))(unsafeToEnum(Data_Date_Component.boundedEnumDay)(1));
    var v = diff(date)(epoch);
    return v;
};
var halfDayInMilliseconds = /* #__PURE__ */ (function () {
    return 12.0 * 3600.0 * 1000.0;
})();
var formatNativeDateTimePicker = function (date) {
    return function __do() {
        var year = map(Data_Number_Format.toString)(Data_JSDate.getFullYear(date))();
        var month = map(function ($47) {
            return Data_Number_Format.toString((function (v) {
                return add(v)(1.0);
            })($47));
        })(Data_JSDate.getMonth(date))();
        var day = map(Data_Number_Format.toString)(Data_JSDate.getDate(date))();
        var hour = map(Data_Number_Format.toString)(Data_JSDate.getHours(date))();
        var minute = map(Data_Number_Format.toString)(Data_JSDate.getMinutes(date))();
        return padLeft("0")(4)(year) + ("-" + (padLeft("0")(2)(month) + ("-" + (padLeft("0")(2)(day) + ("T" + (padLeft("0")(2)(hour) + (":" + padLeft("0")(2)(minute))))))));
    };
};
var formatISOTimeShrinked = function (time) {
    return padLeft("0")(2)(show(fromEnum(Data_Time.hour(time)))) + (":" + padLeft("0")(2)(show(fromEnum1(Data_Time.minute(time)))));
};
var formatISOTime = function (time) {
    return padLeft("0")(2)(show(fromEnum(Data_Time.hour(time)))) + (":" + (padLeft("0")(2)(show(fromEnum1(Data_Time.minute(time)))) + (":" + (padLeft("0")(2)(show(fromEnum2(Data_Time.second(time)))) + ("." + padLeft("0")(3)(show(fromEnum3(Data_Time.millisecond(time)))))))));
};
var formatISODate = function (date) {
    return padLeft("0")(4)(show(fromEnum4(Data_Date.year(date)))) + ("-" + (padLeft("0")(2)(show(fromEnum5(Data_Date.month(date)))) + ("-" + padLeft("0")(2)(show(fromEnum6(Data_Date.day(date)))))));
};
var formatISODateTime = function (v) {
    return formatISODate(v.value0) + ("T" + (formatISOTime(v.value1) + "Z"));
};
var addDays = function (days) {
    return function (date) {
        return Data_DateTime.date(fromJust(adjust(Data_Int.toNumber(days))(new Data_DateTime.DateTime(date, bottom))));
    };
};
export {
    parseISODate,
    formatISODate,
    formatISODateTime,
    formatISOTime,
    formatISOTimeShrinked,
    formatNativeDateTimePicker,
    parseISODateTime,
    parseISODateTimeEither,
    parseISOTime,
    midnightInMillisecondsSinceEpoch,
    halfDayInMilliseconds,
    today,
    addDays
};
